import { Route } from '@angular/router';

export const fullLayoutRoutes: Route[] = [];
